import React from 'react';
import { Link } from 'react-router-dom';
import Error from '../../Components/UiErrorComponents/Error';
import Loading from '../../Components/UiLoadingComponents/Loading';
import { useGetQuizzesQuery } from '../../features/quiz/quizApi';
import SingleQuizTableRow from './SingleQuizTableRow';

const Quizzes = () => {
    const { data, isLoading, isError } = useGetQuizzesQuery()

    let content = null
    if (isLoading) {
        content = <div>
            <Loading className='center-of-window'></Loading>
        </div>
    } else if (isError) {
        content = <Error error='Something went wrong'>
        </Error>
    } else if (!data.length) {
        content = <div className='text-center text-xl text-error mt-5'>
            Data not found please add quiz!
        </div>
    } else {
        content = <div className="overflow-x-auto mt-4">
            <table className="divide-y-1 text-base divide-gray-600 w-full">
                <thead>
                    <tr>
                        <th className="table-th">Question</th>
                        <th className="table-th">Video</th>
                        <th className="table-th justify-center">Action</th>
                    </tr>
                </thead>

                <tbody className="divide-y divide-slate-600/50">

                    {
                        data.map(single => <SingleQuizTableRow key={single.id} data={single}></SingleQuizTableRow>)
                    }
                </tbody>
            </table>
        </div>
    }
    return (
        <section className="py-6 bg-primary">
            <div className="mx-auto max-w-full px-5 lg:px-20">
                <div className="px-3 py-20 bg-opacity-10">
                    <div className="w-full flex">
                        <Link to='/admin/addQuiz' className="btn ml-auto">Add Quiz</Link>
                    </div>
                    {content}
                </div>
            </div>
        </section>
    );
};

export default Quizzes;